export const floatingProgressWrapper = {
  position: "relative",
  height: 24,
  width: "100%",
}

export const floatingProgressGreyBackground = {
  position: "absolute",
  left: 0,
  top: 0,
  height: 24,
  width: "100%",
  borderRadius: 1,
  background: "linear-gradient(90deg, #E6E6E6 0%, #E7E6E6 101.52%)",
}

export const floatingCurrentProgess = {
  position: "relative",
  background: "linear-gradient(270deg, #000000 -0.01%, rgba(0, 0, 0, 0.65) 100%)",
  borderRadius: 1,
  height: 24,
  zIndex: 1,
}

export const floatingBorrowLimitPoint = {
  position: "absolute",
  top: "50%",
  transform: "translateY(-50%)",
  height: 24,
  width: 8,
  backgroundColor: "orange",
  zIndex: 1,
}

export const floatingLiquidationThresholdPoint = {
  ...floatingBorrowLimitPoint,
  backgroundColor: "indianRed",
  zIndex: 1,
}

export const floatingCurrentProgressWave = {
  position: "absolute",
  top: 1,
  left: 1,
  bottom: 1,
  right: 1,
  backgroundImage: `linear-gradient(
      -45deg,
      rgba(255, 255, 255, 0.25) 5%,
      transparent 5%,
      transparent 10%,
      rgba(255, 255, 255, 0.25) 10%,
      rgba(255, 255, 255, 0.25) 15%,
      transparent 15%,
      transparent 20%,
      rgba(255, 255, 255, 0.25) 20%,
      rgba(255, 255, 255, 0.25) 25%,
      transparent 25%,
      transparent 30%,
      rgba(255, 255, 255, 0.25) 30%,
      rgba(255, 255, 255, 0.25) 35%,
      transparent 35%,
      transparent 40%,
      rgba(255, 255, 255, 0.25) 40%,
      rgba(255, 255, 255, 0.25) 45%,
      transparent 45%,
      transparent 50%,
      rgba(255, 255, 255, 0.25) 50%,
      rgba(255, 255, 255, 0.25) 55%,
      transparent 55%,
      transparent 60%,
      rgba(255, 255, 255, 0.25) 60%,
      rgba(255, 255, 255, 0.25) 65%,
      transparent 65%,
      transparent 70%,
      rgba(255, 255, 255, 0.25) 70%,
      rgba(255, 255, 255, 0.25) 75%,
      transparent 75%,
      transparent 80%,
      rgba(255, 255, 255, 0.25) 80%,
      rgba(255, 255, 255, 0.25) 85%,
      transparent 85%,
      transparent 90%,
      rgba(255, 255, 255, 0.25) 90%,
      rgba(255, 255, 255, 0.25) 95%,
      transparent 95%,
      transparent
    );`,
  zIndex: 0,
  backgroundSize: "50px 50px",
  animation: "move 2s linear infinite",
  overflow: "hidden",
}
